import ContentLoader from 'react-content-loader';

const LikesListSkeleton = () => (
  <ContentLoader
    speed={1}
    width="100%"
    height="90vh"
    backgroundColor="#e0e0e0"
    foregroundColor="#c8c8c8"
  >
    <rect x="0" y="0" rx="35" ry="35" width="calc(50% - 10px)" height="220" />
    <rect
      x="calc(50% + 10px)"
      y="0"
      rx="35"
      ry="35"
      width="calc(50% - 10px)"
      height="220"
    />

    <rect x="0" y="240" rx="35" ry="35" width="calc(50% - 10px)" height="220" />
    <rect
      x="calc(50% + 10px)"
      y="240"
      rx="35"
      ry="35"
      width="calc(50% - 10px)"
      height="220"
    />

    <rect x="0" y="480" rx="35" ry="35" width="calc(50% - 10px)" height="220" />
    <rect
      x="calc(50% + 10px)"
      y="480"
      rx="35"
      ry="35"
      width="calc(50% - 10px)"
      height="220"
    />
  </ContentLoader>
);

export default LikesListSkeleton;
